import { FormService } from 'src/app/services/form/form.service';
import { FormGroup } from '@angular/forms';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-form-error-messages',
  templateUrl: './form-error-messages.component.html',
  styleUrls: ['./form-error-messages.component.scss'],
})
export class FormErrorMessagesComponent {
  @Input()
  form: FormGroup;
  @Input()
  controlNames: string | string[];
  @Input()
  errors: string[] = [];
  @Input()
  fontSize: 'sm' | 'md' = 'sm'; // sm: 0.75rem, md: 1rem
  @Input()
  paddingLeft: 'default' | '0' = 'default';
  @Input()
  marginBottom: '0' | 'sm' | 'md' | 'lg' | 'xl' = 'md';

  cssClassName = '';

  constructor(private formSvc: FormService) {}

  public getValidationErrors(): string[] {
    const controlNames = Array.isArray(this.controlNames) ? this.controlNames : [this.controlNames];
    if (!controlNames.length) {
      return [];
    }
    this.cssClassName = controlNames.join(' ');
    return this.formSvc.getErrorsByControlNames(this.form, controlNames);
  }

  public getCssClass(): string {
    const classes = [this.fontSize, 'pl-' + this.paddingLeft, 'mb-' + this.marginBottom, this.cssClassName];
    if (this.getValidationErrors().length + this.errors.length === 1) {
      classes.push('only-1');
    }
    return classes.join(' ');
  }
}
